import { Save, Loader2, Building2 } from 'lucide-react';
import { useEmpresaConfig } from '../../../../hooks/useEmpresaConfig';

const UFS = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

export function DadosEmpresa() {
  const { empresa, setEmpresa, isLoading, isSaving, message, saveEmpresa } = useEmpresaConfig();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (empresa) saveEmpresa(empresa);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 text-brand animate-spin" />
      </div>
    );
  }

  if (!empresa) return null;

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-3xl">
      {message && (
        <div className={`p-4 rounded-lg ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message.text}
        </div>
      )}

      {/* Dados da Empresa */}
      <div className="bg-card border rounded-lg p-6">
        <h3 className="font-semibold text-foreground border-b pb-2 mb-4 flex items-center gap-2">
          <Building2 className="w-5 h-5 text-cyan-600" />
          Dados da Empresa
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Nome da Empresa *</label>
            <input type="text" required value={empresa.nome} onChange={e => setEmpresa({ ...empresa, nome: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">CNPJ *</label>
            <input type="text" required value={empresa.cnpj} onChange={e => setEmpresa({ ...empresa, cnpj: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" placeholder="00.000.000/0001-00" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Email</label>
            <input type="email" value={empresa.email || ''} onChange={e => setEmpresa({ ...empresa, email: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Telefone</label>
            <input type="text" value={empresa.telefone || ''} onChange={e => setEmpresa({ ...empresa, telefone: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" placeholder="(00) 0000-0000" />
          </div>
        </div>
      </div>

      {/* Endereço */}
      <div className="bg-card border rounded-lg p-6">
        <h3 className="font-semibold text-foreground border-b pb-2 mb-4">Endereço</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">CEP</label>
            <input type="text" value={empresa.cep || ''} onChange={e => setEmpresa({ ...empresa, cep: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-foreground mb-1">Logradouro</label>
            <input type="text" value={empresa.logradouro || ''} onChange={e => setEmpresa({ ...empresa, logradouro: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Número</label>
            <input type="text" value={empresa.numero || ''} onChange={e => setEmpresa({ ...empresa, numero: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Complemento</label>
            <input type="text" value={empresa.complemento || ''} onChange={e => setEmpresa({ ...empresa, complemento: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Bairro</label>
            <input type="text" value={empresa.bairro || ''} onChange={e => setEmpresa({ ...empresa, bairro: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Cidade</label>
            <input type="text" value={empresa.cidade || ''} onChange={e => setEmpresa({ ...empresa, cidade: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card" />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Estado</label>
            <select value={empresa.estado || ''} onChange={e => setEmpresa({ ...empresa, estado: e.target.value })}
              className="w-full px-3 py-2 border border-input rounded-lg text-foreground bg-card">
              <option value="">Selecione</option>
              {UFS.map(uf => (
                <option key={uf} value={uf}>{uf}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <button type="submit" disabled={isSaving} className="flex items-center gap-2 px-6 py-2 btn btn-primary disabled:opacity-50">
          {isSaving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Salvar Configurações
        </button>
      </div>
    </form>
  );
}
